import store from 'surface/xstore'
import sortBy from 'lodash.sortby'
import { Post } from 'types'
import { $ } from 'bits/jquery'

function getAbsoluteSortIndex (
  ts: Date | number = new Date(),
  wallCreatedAt = store.getters.wallCreatedAt,
): number {
  const timestamp = (ts instanceof Date) ? ts.getTime() : ts
  const absSortIndex = 1024 * (timestamp - new Date(wallCreatedAt).getTime())
  return absSortIndex
}

function getSortIndex (): number {
  const postAtBottom = store.getters.newPostLocation === 'bottom'
  const absSortIndex = getAbsoluteSortIndex()
  return postAtBottom ? -absSortIndex : absSortIndex
}

function getTopSortIndex (): number {
  return getAbsoluteSortIndex()
}

function getBottomSortIndex (): number {
  return -getAbsoluteSortIndex()
}

interface ComputeNewPostIndexOptions {
  sectionId?: number
  prevId?: string
  nextId?: string
}

function computeAndSaveNewPostIndex (post, options: ComputeNewPostIndexOptions = {}): void {
  const $post = $(post)
  const sectionId = options.sectionId

  let $prev
  if (options.prevId === undefined) {
    $prev = $post.prev('.wish')
  } else if (options.prevId != null) {
    $prev = $(`#${options.prevId}`)
  } else {
    $prev = $([])
  }

  let $next
  if (options.nextId === undefined) {
    $next = $post.next('.wish')
  } else if (options.nextId != null) {
    $next = $(`#${options.nextId}`)
  } else {
    $next = $([])
  }

  let nextIndex,
    prevIndex,
    sortIndex
  if ($next.length === 0 && $prev.length === 0) {
    sortIndex = (sectionId === null) ? null : getSortIndex()
  } else {
    if ($next.length === 0) {
      nextIndex = getBottomSortIndex()
    } else if ($prev.length === 0) {
      prevIndex = getTopSortIndex()
    }
    if (nextIndex == null) {
      nextIndex = parseInt($next.attr('data-rank'), 10)
    }
    if (prevIndex == null) {
      prevIndex = parseInt($prev.attr('data-rank'), 10)
    }
    sortIndex = Math.round((prevIndex + nextIndex) / 2)
  }

  if (!sortIndex) return
  store.dispatch('post/sortedPost', {
    postCid: $post.data('post-cid'),
    sortIndex: sortIndex,
    sectionId: sectionId,
  })
}

function sortPostsByDate (posts: Post[]): Post[] {
  return sortBy(posts, (post: Post): any => {
    return post.id ? post.created_at : new Date()
  })
}

function sortPostsBySortIndex (posts: Post[]): Post[] {
  return sortBy(posts, (post: Post): number | undefined => {
    if (post.sort_index) {
      return post.sort_index
    }
    const oldRank = parseInt(((post.rank || '') + new Date(post.created_at as string).getTime()), 10)
    return Math.abs(getAbsoluteSortIndex(oldRank))
  }).reverse()
}

export {
  getTopSortIndex,
  getBottomSortIndex,
  getSortIndex,
  computeAndSaveNewPostIndex,
  sortPostsByDate,
  sortPostsBySortIndex,
}
